import {createAsyncThunk} from '@reduxjs/toolkit'

import {SHOPPING_MY_SUBSCRIPTION} from '@web/core/urls'
import {
    browserAlert,
    changeBrowserLocation,
    openPopup,
    subscribeNoKeyMessage,
    unsubscribeNoKeyMessage,
} from '@web/helpers/browser'
import {isPC} from '@web/helpers/userAgent'
import {CommonState} from '@web/slices/common/slice'

import {NavigationResult, NavigationTypeSelectableParam} from '../interfaces'

const POPUP_KEY = 'SHOPPING_SUBSCRIPTION_SUBSCRIPTION_DETAIL'
const senderChecker = (sender?: MessageEventSource) => {
    return !!sender
}

const navigateToShoppingMySubscription = createAsyncThunk<
    NavigationResult,
    NavigationTypeSelectableParam & {deliveryId: string; scheduleId: string},
    {
        state: {
            common: CommonState
        }
    }
>('navigateTo/shoppingMySubscription', async (args) => {
    const {forceLocationChange = false, deliveryId, scheduleId} = args ?? {}

    const url = SHOPPING_MY_SUBSCRIPTION
    const shouldChangeLocation = forceLocationChange || !isPC

    if (deliveryId && scheduleId) {
        const subscriptionDetailPageUrl = `${url}/${deliveryId}/schedules/${scheduleId}`

        if (shouldChangeLocation) {
            changeBrowserLocation({
                url: subscriptionDetailPageUrl,
                type: 'PUSH',
            })
            return Promise.resolve()
        }

        return new Promise<void | string>((resolve, reject) => {
            const resolveCallback = (
                e?: string | {action: string; data: {scheduleStatusType?: string; url?: string}},
            ) => {
                if (!e) {
                    return
                }

                /** [description] 구버전 코드.. 케이스 미상 */
                if (typeof e === 'string') {
                    e === 'SUCCESS' && location.reload()
                } else if (
                    /** 정기구독 빨리받기 결제 완료 */
                    e.action === 'CHANGE_SUBSCRIPTION_STATUS' &&
                    e.data?.scheduleStatusType === 'TAKE_COMPLETED'
                ) {
                    changeBrowserLocation({
                        url: e.data?.url ?? '',
                        type: 'PUSH',
                    })
                }
            }

            // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
            subscribeNoKeyMessage({senderChecker, subscriber: resolveCallback})

            openPopup({
                key: POPUP_KEY,
                url: subscriptionDetailPageUrl,
                size: {
                    width: 500,
                    height: 640,
                },
            })
                .then(() => resolve())
                .catch(reject)
                .finally(() => {
                    // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                    unsubscribeNoKeyMessage(senderChecker)
                })
        })
    } else {
        browserAlert({message: '정기구독 정보가 올바르지 않습니다. 정기구독 목록 페이지로 이동합니다.'})
        changeBrowserLocation({
            url,
            type: 'PUSH',
        })
    }
})

export default navigateToShoppingMySubscription
